/* eslint-disable */
import { CropPortrait } from '@material-ui/icons';
import { React, Fragment, Component } from 'react';
import Button from '@material-ui/core/Button';
// import Typography from '@material-ui/Typography';
// import Breadcrumbs from '@material-ui/Breadcrumbs';
// import Link from '@material-ui/Link';

// function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
//   event.preventDefault();
//   console.info('You clicked a breadcrumb.');
// }
import moment from 'moment';

import DataTable from 'react-data-table-component';
import Select from 'react-select'

import Spinner from 'components/Spinner.js';

const columns = [
  {
      name: 'Role',
      selector: row => row.name,
      sortable: true,
  },
  {
    name: 'Description',
    selector: row => row.description,
    sortable: true,
  },
];

export default class UserList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTable: false,
      showSpinner: true,
      showSelect: false,
      site: null,
      sites: [],
      data: []
    };
  }

  componentDidMount() {
    var $this = this;
    fetch('/api/shared/roles/list/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({})
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          $this.setState({
            data: data.data.roles,
            showSpinner: false,
            showTable: true
          });
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  render ()
  {
    var $this = this;
    return (
      <Fragment>
        { this.state.showSpinner ?
          <Spinner/> 
          : "" 
        }
        { this.state.showTable ?
        <DataTable
              columns={columns}
              data={this.state.data}
              keyField='id'
              onRowClicked={r => this.props.setId(r.id)}
              striped
              highlightOnHover
              pointerOnHover
              dense
              pagination
          />
          : ""
        }
        <Button variant="contained" color="primary" onClick={() => $this.props.setId(null)}>Add New Role</Button>
      </Fragment>
    );
  }
}
